module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-MediumItalic.6cc93eb.woff2";